<template>
    <va-edit-layout>
        <MwsConfiguration-form
            :id="id"
            :title="title"
            :item="item"
        ></MwsConfiguration-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
